/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ApartmentInputs */

const cs_enum_apartment = /** @type {(inputs: Enum_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byt`)
};

const en_enum_apartment = /** @type {(inputs: Enum_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartment`)
};

/**
* | output |
* | --- |
* | "Apartment" |
*
* @param {Enum_ApartmentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_apartment = /** @type {((inputs?: Enum_ApartmentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ApartmentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_apartment(inputs)
	return cs_enum_apartment(inputs)
});